import createElementChangeListener from "../../elementChangeListener";
import curry from "../../lib/core/functional/curry";
import makeTransportContext from "../../utils/makeTransportContext";
import { dispatchNextPage } from "../../transport/nextPage";

import { renderLoaded } from "./_common";

const onLoaded = curry((element, [data, _pageNumber]) => renderLoaded(element, data));

const loadElement = curry(function loadElement(context, element) {
    if ("hasMore" in element.dataset && element.dataset.hasMore !== "true") {
        return;
    }

    if ("morePostsExists" in element.dataset && element.dataset.morePostsExists !== "true") {
        return;
    }

    dispatchNextPage(makeTransportContext(element, context)).then(onLoaded(element));
});

export default function loadContentOnPostLcp(context) {
    createElementChangeListener(".rm-lazy-load-post-lcp-wrapper", loadElement(context));
}
